(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kwwig-pony-filter"] && !Shopify.designMode) return;
  try {
    function keepKwwigFilterParams(event) {
    const link = event.target.closest('[data-kwwig-filter-link]');
    if (!link) return;
    const target = new URL(link.href, window.location.origin);
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    target.search = params.toString();
    link.href = target.href;
  }
  document.addEventListener('click', keepKwwigFilterParams, true);
  document.addEventListener('auxclick', keepKwwigFilterParams, true);
  } catch(e) { console.error(e); }
})();

})();
